import { Box, IconButton, TableCell, TableRow, Tooltip } from "@mui/material";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";
import BasicMenu from "./SortingTableMenu";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState } from "react";

interface TableRowFolderProps {
  handleClickSelectRow: (event: React.MouseEvent<unknown>, selectedRow: ExamOverviewRow) => void;
  row: ExamOverviewRow;
  isItemSelected: boolean | undefined;
  openFolder: (folderName: string) => void;
  labelId: string;
  selected: ExamOverviewRow | null;
}

export const TableRowFolder = ({
  handleClickSelectRow,
  row,
  isItemSelected,
  openFolder,
  labelId,
  selected,
}: TableRowFolderProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (event: React.MouseEvent | React.TouchEvent) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <TableRow
        hover
        onClick={(event) => handleClickSelectRow(event, row)}
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={row.id}
        selected={isItemSelected}
        sx={{ cursor: "pointer" }}
        onDoubleClick={() => openFolder(row.name)}
      >
        <TableCell component="th" id={labelId} scope="row" padding="none">
          <FolderOpenIcon />
        </TableCell>
        {Object.keys(row)
          .filter((key) => key !== "isDirectory" && key !== "showOptions" && key !== "id")
          .map((key) => (
            <TableCell key={key} align="left">
              {row[key as keyof ExamOverviewRow]}
            </TableCell>
          ))}
        <TableCell align="left" sx={{ padding: "0 16px" }}>
          {row.id === selected?.id && (
            <Box>
              <Tooltip title="Aktionen anzeigen">
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    handleClickOpenMenu(event);
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          <BasicMenu
            anchorEl={anchorEl}
            open={open}
            handleCloseMenu={handleCloseMenu}
            rowSelected={selected}
            openItem={openFolder}
          />
        </TableCell>
      </TableRow>
    </>
  );
};
